"use client";

import { type JSX } from "react";
import {
  AtomicLayoutSection,
  AtomicSortDropdown,
  AtomicSortExpression,
} from "@coveo/atomic-react";
import { ClientOnly } from "../../../atoms/ClientOnly";
import { parseKvpField } from "../../../utils/sitecoreUtils";
import { type SearchSortFacetProps } from "./search-sort-facet.props";

const SORT_FACET_STYLES = `
  @media (max-width: 390px) {
    .search-sort-facet {
      width: 180px;
      padding-left: 16px;
    }
    atomic-sort-dropdown::part(select) {
      padding-right: 68px;
    }
  }
`;

// Note: must be rendered inside a <SearchContainer> (which provides
// AtomicSearchInterface). Wrapping in AtomicPageWrapper here would create
// a nested AtomicSearchInterface conflict.
export const Default = (props: SearchSortFacetProps): JSX.Element => {
  console.log(
    "---->[SearchSortFacet:Default] Component",
    props.fields,
    props.params?.SearchScope,
  );

  const { fields, params } = props;
  const id = params?.RenderingIdentifier;
  const sortOptionsRaw = fields?.SortOptions?.value
    ? fields?.SortOptions?.value
    : "";
  const sortExpressions = parseKvpField(sortOptionsRaw);
  const expressionEntries = Object.entries(sortExpressions);

  return (
    <div
      className={`search-sort-facet flex justify-end pr-(--spacing-sixteen) ${params?.styles ?? ""}`}
      data-role="search-sort-facet-component"
    >
      <ClientOnly>
        <style>{SORT_FACET_STYLES}</style>
        <AtomicLayoutSection id={id ?? undefined} section="facets">
          {expressionEntries.length > 0 && (
            <AtomicSortDropdown>
              {expressionEntries.map(([label, expression]) => (
                <AtomicSortExpression
                  key={label}
                  label={label}
                  expression={expression}
                />
              ))}
            </AtomicSortDropdown>
          )}
        </AtomicLayoutSection>
      </ClientOnly>
    </div>
  );
};
